import { render, staticRenderFns } from "./navbar-logo.vue?vue&type=template&id=494d07f5&scoped=true&"
import script from "./navbar-logo.vue?vue&type=script&lang=js&"
export * from "./navbar-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d07f5",
  null
  
)

export default component.exports